/**
 * Type guard for whether a parsed field is an object field
 *
 * @param field The value to test.
 * @returns True if the field is a ParsedObjectField
 */
export function isObjectField(field) {
    return "children" in field && "isArray" in field && field.isArray === false;
}
/**
 * Type guard for whether a parsed field is an array field
 *
 * @param field The value to test.
 * @returns True if the field is a ParsedArrayField
 */
export function isArrayField(field) {
    return "children" in field && "isArray" in field && field.isArray === true;
}
/**
 * Type guard for whether a field is a sub-type with children.
 *
 * @param field The field to test
 * @returns True if the field is a sub-type with children.
 */
export function isParentField(field) {
    return isObjectField(field) || isArrayField(field);
}
/**
 * Type guard for whether a parsed field is a union field.
 *
 * @param field The value to test.
 * @returns True if the field is a ParsedUnionField
 */
export function isUnionField(field) {
    return "options" in field;
}
//# sourceMappingURL=typeGuards.js.map